import { Pipe, PipeTransform } from '@angular/core';
import { MenuItemDto } from '../../../services/akita/menu-item-schema/menu-item.dto';
import { DataParser } from "../../../services";

@Pipe({
  name: 'getMenuShowMinusIcon'
})
export class GetMenuShowMinusIconPipe implements PipeTransform {

  protected dParser: DataParser;

  transform(menuDto: MenuItemDto, menuDtos: MenuItemDto[]): string {

    let classes = 'fa fa-minus pb-2 pt-2';

    if (menuDto.isCurrentPage) {
      const selectedChild = menuDtos.find(m => m.isCurrentPage && menuDto.menuItem.id === m.menuItem.data.parentMenuItem.iv[0]);
      if (!selectedChild) {
        classes += ' text-white';
      }
    }

    let showIcon = ' d-inline';
    if (!menuDto.isVisible && !menuDto.isCurrentPage) {
      showIcon = ' d-none';
    }

    return classes + showIcon;

  }
}
